import Apply from 'components/templates/Apply';
export default Apply;
